export default __webpack_public_path__ + "static/media/img_placeholder.ccd4d743.svg";